import { render, staticRenderFns } from "./MyCode.vue?vue&type=template&id=62cd48f5&scoped=true&"
import script from "./MyCode.vue?vue&type=script&lang=js&"
export * from "./MyCode.vue?vue&type=script&lang=js&"
import style0 from "./MyCode.vue?vue&type=style&index=0&id=62cd48f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd48f5",
  null
  
)

export default component.exports